
import { z } from 'zod';
import { BookingInfoSchema } from '../booking/BookingSchema';

export type OrderInfoSchema = {
  orderId:  string,
  orderName: string,
  site: string,
  siteId: string,
  customer: string,
  container: string,
  orderIndexAct: number,
  rotation: string,
  numberOfLoops: number,
  orderLength: number,
  orderBegin: Date,
  orderEnd: Date,
  isDeleted: boolean,
  error: string,
  bookings: BookingInfoSchema[],
  selected: boolean 

}

const dateNullable = z.preprocess(
  v => (v === '' || v == null ? null : v),
  z.coerce.date().nullable()
);

export const dateRequired = z.preprocess(
  v => (v === '' || v == null ? undefined : v),   // make empty/null fail as "required"
  z.coerce.date({
    required_error: "Date is required",
    invalid_type_error: "Invalid date",
  })
);

export const SitesSchema = z.object({
siteId: z.string().uuid().nullish(),  
orderContainerId: z.string().uuid(),  
lineId: z.number().nullable().optional()

})

export const OrderSchema = z.object({
  orderId: z.string().uuid().optional().nullable(),
  orderName: z.string(),
  siteId: z.string().uuid().optional(),
  lineId: z.number().optional(),
  customerId: z.string().uuid(),
  orderContainerId: z.string().uuid().optional(),
  rotation: z.number(),
  orderBegin: dateRequired,
  orderEnd: dateRequired,
  orderLength: z.number(),
  aspectRatios : z.array(z.string()).optional().nullable(),
  orderSites: z.array(SitesSchema).optional()//for new orders only
  
})


